import {ColorsType} from '../../../../styles/Colors';
import {StyleType} from '../../../../styles';

export const styles = (
  colors: ColorsType,
  fontStyles: StyleType,
  background_color?: string,
  verifiedIcon?: boolean,
  hasGradient?: boolean,
) => {
  return {
    credCardContainer: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: !background_color ? colors.neutral100 : background_color,
      borderRadius: 3.231,
      width: 90.604,
      maxHeight: 56,
      minHeight: 56,
      boxSizing: 'border-box',
      alignSelf: 'stretch' as 'stretch',
      boxShadow: '0px 0px 3.231px 0px rgba(14, 14, 54, 0.16)',
    } as React.CSSProperties,
    linearGradientOverlay: {
      padding: 5.385,
      display: 'flex',
      flexDirection: 'column' as 'column',
      borderRadius: 3.231,
      alignSelf: 'stretch' as 'stretch',
      height: '100%',
      background: hasGradient
        ? 'linear-gradient(140deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.6) 100%)'
        : 'transparent',
      gap: 3,
    } as React.CSSProperties,
    credCardMainContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
      minHeight: 24.2,
    } as React.CSSProperties,
    credCardTopData: {
      display: 'flex',
      alignSelf: 'stretch',
    } as React.CSSProperties,
    credCardDetailRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: 3.17,
    } as React.CSSProperties,
    credIssuerImageError: {
      display: 'flex',
      alignItems: 'center' as 'center',
      justifyContent: 'flex-start' as 'flex-start',
      alignSelf: 'flex-start' as 'flex-start',
      gap: 1.962,
      flexDirection: 'row' as 'row',
      ...fontStyles['bodyBoldCap'],
      lineHeight: fontStyles['bodyBoldCap']?.lineHeight + 'px',
    } as React.CSSProperties,
    credCardIssuerImage: {
      maxHeight: 5.89,
      maxWidth: !!verifiedIcon ? 'calc(100% - 12px)' : 'calc(100%)',
      width: 'auto',
      height: 'auto',
      objectFit: 'contain' as 'contain',
    } as React.CSSProperties,
    credCardVerifiedIcon: {
      marginLeft: 'auto',
      display: 'flex',
      alignItems: 'flex-start' as 'flex-start',
      justifyContent: 'flex-end' as 'flex-end',
    } as React.CSSProperties,
  };
};
